import { OrdersFilterStateProps } from "../orders.types";
import { OrderStatus } from "./enums";

export const EMPTY_ORDERS_FILTER_FORM_VALUES: OrdersFilterStateProps = {
  gender: undefined,
  unpackingStatus: undefined,
  driverId: "",
  createdFrom: undefined,
  createdTo: undefined,
  orderTotalFrom: undefined,
  orderTotalTo: undefined,
  deliveryZoneId: "",
  statuses: [],
  clientName: undefined,
  clientPhone: undefined,
  resellerName: undefined,
  resellerPhone: undefined,
  deliveryLocation: undefined,
  type: undefined
};

export const ORDER_TYPE_FILTER_SEARCH_PARAMETER = "type";
export const UNPACKING_STATUS_FILTER_SEARCH_PARAMETER = "unpackingStatus";
export const GENDER_FILTER_SEARCH_PARAMETER = "gender";
export const DRIVER_ID_FILTER_SEARCH_PARAMETER = "driverId";
export const CREATED_FROM_FILTER_SEARCH_PARAMETER = "createdFrom";
export const CREATED_TO_FILTER_SEARCH_PARAMETER = "createdTo";
export const TOTAL_FROM_FILTER_SEARCH_PARAMETER = "orderTotalFrom";
export const TOTAL_TO_FILTER_SEARCH_PARAMETER = "orderTotalTo";
export const LOCATION_ID_FILTER_SEARCH_PARAMETER = "deliveryZoneId";
export const STATUS_FILTER_SEARCH_PARAMETER = "statuses";
export const CLIENT_NAME_FILTER_SEARCH_PARAMETER = "clientName";
export const CLIENT_PHONE_FILTER_SEARCH_PARAMETER = "clientPhone";
export const RESELLER_NAME_FILTER_SEARCH_PARAMETER = "resellerName";
export const RESELLER_PHONE_FILTER_SEARCH_PARAMETER = "resellerPhone";
export const DELIVERY_LOCATION_FILTER_SEARCH_PARAMETER = "deliveryLocation";

export const ORDER_FILTER_SEARCH_PARAMETERS = [
  UNPACKING_STATUS_FILTER_SEARCH_PARAMETER,
  GENDER_FILTER_SEARCH_PARAMETER,
  DRIVER_ID_FILTER_SEARCH_PARAMETER,
  CREATED_FROM_FILTER_SEARCH_PARAMETER,
  CREATED_TO_FILTER_SEARCH_PARAMETER,
  TOTAL_FROM_FILTER_SEARCH_PARAMETER,
  TOTAL_TO_FILTER_SEARCH_PARAMETER,
  LOCATION_ID_FILTER_SEARCH_PARAMETER,
  STATUS_FILTER_SEARCH_PARAMETER,
  CLIENT_NAME_FILTER_SEARCH_PARAMETER,
  CLIENT_PHONE_FILTER_SEARCH_PARAMETER,
  RESELLER_NAME_FILTER_SEARCH_PARAMETER,
  RESELLER_PHONE_FILTER_SEARCH_PARAMETER,
  DELIVERY_LOCATION_FILTER_SEARCH_PARAMETER,
  ORDER_TYPE_FILTER_SEARCH_PARAMETER
] as const;

export const AVAILABLE_TO_CANCEL_ORDER_STATUSES = [
  OrderStatus.Placed,
  OrderStatus.Collecting,
  OrderStatus.Active
];
